import React, { useState, useEffect } from "react";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import Footer from "../Footer/Footer";
import SearchHistory from "./SearchHistory";
import RecentHistory from "./RecentHistory";
import PamCodeSearch from "../AdminPages/SearchPincodeOrState";

interface CustomJwtPayload {
    RoleId: string;
}

type TabType = 'search' | 'location' | 'recent';

const SearchSummary: React.FC = () => {
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState<TabType>('search');

    useEffect(() => {
        const token = localStorage.getItem('token');
        if (!token) {
            toast.error("No auth token found. Please log in.");
            navigate('/');
        } else {
            try {
                const decodedToken = jwtDecode<CustomJwtPayload>(token);
                if (decodedToken.RoleId !== "1") {
                    toast.error("Unauthorized access: RoleId is not 1");
                    navigate('/');
                }
            } catch (error) {
                toast.error("Invalid token. Please log in again.");
                navigate('/');
            }
        }
    }, [navigate]);

    return (
        <div className="min-h-screen bg-magnolia flex flex-col">
            <div className="flex flex-col h-screen">
                <header className="bg-white px-4 sm:px-6 py-3 flex items-center justify-between">

                    {/* Tab Navigation */}
                    <div className="border-b border-gray-200">
                        <nav className="flex space-x-6 relative">

                            {/* Search History */}
                            <button
                                onClick={() => setActiveTab('search')}
                                className={`relative py-3 text-sm font-medium transition-colors ${activeTab === 'search'
                                    ? 'text-indigo-600'
                                    : 'text-gray-500 hover:text-gray-700'
                                    }`}
                            >
                                Search History

                                {activeTab === 'search' && (
                                    <span className="absolute left-0 -bottom-[1px] w-full h-[2px] bg-indigo-600 rounded-full"></span>
                                )}
                            </button>

                            {/* Search by Location */}
                            <button
                                onClick={() => setActiveTab('location')}
                                className={`relative py-3 text-sm font-medium transition-colors ${activeTab === 'location'
                                    ? 'text-indigo-600'
                                    : 'text-gray-500 hover:text-gray-700'
                                    }`}
                            >
                                Search Location

                                {activeTab === 'location' && (
                                    <span className="absolute left-0 -bottom-[1px] w-full h-[2px] bg-indigo-600 rounded-full"></span>
                                )}
                            </button>

                            {/* Recent History */}
                            <button
                                onClick={() => setActiveTab('recent')}
                                className={`relative py-3 text-sm font-medium transition-colors ${activeTab === 'recent'
                                    ? 'text-indigo-600'
                                    : 'text-gray-500 hover:text-gray-700'
                                    }`}
                            >
                                Recent History

                                {activeTab === 'recent' && (
                                    <span className="absolute left-0 -bottom-[1px] w-full h-[2px] bg-indigo-600 rounded-full"></span>
                                )}
                            </button>

                        </nav>
                    </div>

                </header>

                <main className="flex-1 overflow-auto">
                    {activeTab === 'search' && <SearchHistory />}

                    {activeTab === 'location' && <PamCodeSearch showTitle={false} />}

                    {activeTab === 'recent' && <RecentHistory />}
                </main>

                <ToastContainer />
                <Footer />
            </div>
        </div>
    );
};

export default SearchSummary;
